
export default {
  name: 'MoleculeListCircle'
}
